import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, inject } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { getShowPricesWithTax } from '@app/checkout/modules/checkout-shared/reducers/checkout.reducer';
import { ProductPriceRequest } from '@app/product/reducers/product.reducer';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';

/** Product Price Component */
@Component({
	selector: 'g-product-price',
	templateUrl: './product-price.component.html',
	styleUrls: ['./product-price.component.scss'],
	animations: [
		trigger('spinnerTrigger', [
			transition(':enter', [style({ opacity: 0 }), animate('100ms 200ms', style({ opacity: 1 }))]),
			transition(':leave', [animate('100ms', style({ opacity: 0 }))]),
		]),
	],
	standalone: false,
})
export class ProductPriceComponent {
	private readonly store = inject<Store<RootReducer.State>>(Store);

	@Input() readonly price?: ProductPriceRequest | null;
	@Input() readonly isVariableProduct = false;
	readonly icons = { faSpinner };
	readonly showPricesWithTax$ = this.store.select(getShowPricesWithTax);
}
